import {
    LovValueSummaryFindAllService
} from '../../../../../common/lov/lov-value/impl/service/lovValueSummaryFindAll.service';
import {Inject, Injectable} from '@angular/core';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {CachedtFindAllService} from '../../../../../core/service/v2/service/findAll/cachedtFindAll.service';
import {LovValue} from '../../../../../common/lov/lov-value/api/model/LovValue.model';
import {UrlParameterBuilder} from '../../../../../core/http/UrlParameterBuilder';
import {Order, Sort} from '../../../../../../shared/utils/url.builder';
@Injectable({
    providedIn: 'root',
})
export class MedicalRecordVisitReasonLabelsCachedFindAllService extends CachedtFindAllService<LovValue, LovValueSummary>{

    constructor(private lovService: LovValueSummaryFindAllService) {
        super(lovService, new UrlParameterBuilder()
            .addInParameter('list.name', ['MEDICAL_RECORD_VISIT_REASON_LABEL', 'MEDICAL_RECORD_PAIN_WHERE'])
            .parameters, new Sort('label', Order.ASCENDING));
        console.log('new MedicalRecordVisitReasonLabelsCachedFindAllService');
    }
}
